module.exports = __webpack_public_path__ + "static/sec4-bg-770b3cd1de051a88874d15309762a818.jpg";